import { aboutInfo } from "@/mocks/aboutData";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { WebPageSchema, BreadcrumbListSchema, FAQPageSchema, OrganizationSchema } from "@/components/feature/StructuredData";

const faqItems = [
  {
    question: "红桃影院的综艺节目需要付费观看吗？",
    answer: "红桃影院所有综艺节目均为免费观看，无需付费。我们致力于为用户提供高品质、正能量的综艺内容，让每一位用户都能免费享受精彩娱乐。",
  },
  {
    question: "综艺节目更新频率是怎样的？",
    answer: "红桃影院与各大综艺节目保持同步更新，热门综艺每周固定更新，最新上线内容第一时间同步。用户可在首页「最新上线」专区查看最新的综艺节目。",
  },
  {
    question: "支持哪些设备观看综艺节目？",
    answer: "红桃影院支持电脑、平板、手机等多种设备观看，页面已针对不同屏幕尺寸进行适配优化。只需打开浏览器访问红桃影院网站，即可随时随地观看精彩综艺。",
  },
  {
    question: "如何搜索想看的综艺节目？",
    answer: "在红桃影院首页顶部的搜索框中输入综艺节目名称即可快速查找。此外，您也可以通过「分类浏览」按真人秀、搞笑综艺、音乐综艺等分类进行筛选浏览。",
  },
];

export default function AboutPage() {
  return (
    <>
      <OrganizationSchema />
      <WebPageSchema
        name="关于我们 - 红桃影院"
        url="https://hongtao-movie.com/about"
        description="红桃影院品牌介绍：致力于为用户提供高品质综艺在线观看服务。了解红桃影院的品牌故事、发展历程、用户口碑和联系方式。"
      />
      <BreadcrumbListSchema
        items={[
          { name: "首页", url: "https://hongtao-movie.com" },
          { name: "关于我们", url: "https://hongtao-movie.com/about" },
        ]}
      />
      <FAQPageSchema items={faqItems} />

      <Breadcrumb />

      <main className="w-full px-4 md:px-6 py-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 mb-4">
              <div className="w-12 h-12 bg-primary-500 rounded-xl flex items-center justify-center">
                <i className="ri-heart-fill text-background-50 text-2xl"></i>
              </div>
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
              关于红桃影院
            </h1>
            <p className="text-lg text-foreground-500 max-w-xl mx-auto">
              {aboutInfo.slogan}
            </p>
          </div>

          <section className="grid grid-cols-2 sm:grid-cols-4 gap-5 mb-16">
            {aboutInfo.stats.map((stat) => (
              <div
                key={stat.label}
                className="text-center p-5 bg-background-100 rounded-xl"
              >
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading mb-1">
                  {stat.number}
                </div>
                <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </section>

          <section className="mb-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div>
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-5">
                  品牌故事
                </h2>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
                  红桃影院成立于{aboutInfo.founded}，是国内领先的综艺节目在线观看平台。
                  {aboutInfo.mission}
                </p>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base mt-4">
                  {aboutInfo.vision}
                </p>
              </div>
              <div>
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-5">
                  核心价值
                </h2>
                <div className="space-y-4">
                  {aboutInfo.values.map((value) => (
                    <div key={value.title} className="flex gap-4">
                      <div className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-1.5 flex-shrink-0"></div>
                      <div>
                        <h3 className="text-base font-semibold text-foreground-800 mb-1">
                          {value.title}
                        </h3>
                        <p className="text-sm text-foreground-500 leading-relaxed">
                          {value.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section id="reputation" className="mb-16">
            <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-2 text-center">
              用户口碑
            </h2>
            <p className="text-foreground-500 text-sm text-center mb-10">
              听听用户们怎么说
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {aboutInfo.reputation.map((review, index) => (
                <div
                  key={index}
                  className="p-5 bg-background-100 rounded-xl border border-background-200/60"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                      <i className={`${review.avatar} text-lg`}></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{review.name}</p>
                      <p className="text-xs text-foreground-400">{review.date}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-0.5 mb-3">
                    {Array.from({ length: review.rating }, (_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {review.comment}
                  </p>
                </div>
              ))}
            </div>
          </section>

          <section id="contact" className="mb-16">
            <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-2 text-center">
              联系我们
            </h2>
            <p className="text-foreground-500 text-sm text-center mb-10">
              有任何问题或建议？欢迎联系我们
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              <div className="flex flex-col items-center p-6 bg-background-100 rounded-xl border border-background-200/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-400 mb-1">电子邮箱</p>
                <p className="text-sm font-medium text-foreground-800">{aboutInfo.contact.email}</p>
              </div>
              <div className="flex flex-col items-center p-6 bg-background-100 rounded-xl border border-background-200/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-400 mb-1">客服电话</p>
                <p className="text-sm font-medium text-foreground-800">{aboutInfo.contact.phone}</p>
              </div>
              <div className="flex flex-col items-center p-6 bg-background-100 rounded-xl border border-background-200/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-400 mb-1">公司地址</p>
                <p className="text-sm font-medium text-foreground-800 text-center">{aboutInfo.contact.address}</p>
              </div>
              <div className="flex flex-col items-center p-6 bg-background-100 rounded-xl border border-background-200/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-400 mb-1">微信/微博</p>
                <p className="text-sm font-medium text-foreground-800">{aboutInfo.contact.weibo}</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-2 text-center">
              常见问题
            </h2>
            <p className="text-foreground-500 text-sm text-center mb-10">
              快速解答你的疑问
            </p>

            <div className="max-w-2xl mx-auto space-y-3">
              {faqItems.map((faq, index) => (
                <details
                  key={index}
                  className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
                >
                  <summary className="flex items-center justify-between p-5 cursor-pointer">
                    <span className="text-sm font-medium text-foreground-800 pr-4">
                      {faq.question}
                    </span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </section>
        </div>
      </main>
    </>
  );
}